import './DashboardCard.css';
import WalletIcon from '../../../assets/icons/wallet.svg?react';
import SimpleBarChart from './SimpleBarChart';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
const PowerPriceCard = ({ colSpan = 1, rowSpan = 1, dashboardData = {} }) => {
  const { 
    kpxSmpRangeData, 
    kpxSmpRangeLoading, 
    kpxSmpRangeError,
    lastUpdateTime
  } = dashboardData;
  
  // 안전한 데이터 접근
  const smpInfos = kpxSmpRangeData?.response?.[0]?.smpInfos || [];
  
  // 현재 단가 계산 (lastUpdateTime 기반 또는 첫 번째 데이터 fallback)
  const [currentPrice, setCurrentPrice] = useState(0);
  
  useEffect(() => {
    if (smpInfos.length === 0) {
      setCurrentPrice(0);
      return;
    }
    if (lastUpdateTime) {
      // lastUpdateTime이 있으면 해당 시간의 데이터 찾기
      const targetHour = dayjs(lastUpdateTime).format('HH');
      const matchingItem = smpInfos.find(item => item.time === targetHour);
      if (matchingItem) {
        setCurrentPrice(matchingItem.smp);
        return;
      }
    }
  }, [lastUpdateTime, smpInfos]);
  
  // 차트 데이터 변환 (안전한 처리)
  const chartData = Array.isArray(smpInfos) ? smpInfos.map((item, index) => ({
    label: item.time,
    value: item.smp
  })) : [];
  
  return (
    <div 
      className="dashboard-card flex flex-col justify-between" 
    >
      <h3 className="text-b1-700 text-gray-700">전력 단가</h3>
      <div className="grid grid-cols-2 gap-10">
        <div className='flex flex-col justify-around'>
          <div className="flex align-center gap-10 rounded px-10 py-5 bg-dashboard-price">
            <div className="icon-container icon-primary">
              <WalletIcon/>
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-b2-700 text-dashboard-price-text">현재 단가</p>
              <p className="text-h2 text-dashboard-price-text">
              {kpxSmpRangeLoading ? '로딩 중...' : 
                kpxSmpRangeError ? '데이터 없음' : 
                currentPrice > 0 ? `${currentPrice}원/kWh` : '데이터 없음'}
              </p>
            </div>
          </div>
        </div>
        <div>
          {kpxSmpRangeLoading ? (
            <div className="flex items-center justify-center h-32 text-gray-500">
              데이터 로딩 중...
            </div>
          ) : kpxSmpRangeError ? (
            <div className="flex items-center justify-center h-32 text-red-500">
              데이터를 불러올 수 없습니다
            </div>
          ) : chartData.length > 0 ? (
            <SimpleBarChart 
              data={chartData}
              activeIndex={chartData.findIndex(item => item.label === dayjs(lastUpdateTime).format('HH'))}
              className="power-price-chart"
            />
          ) : (
            <div className="flex items-center justify-center h-32 text-gray-500">
              차트 데이터가 없습니다
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PowerPriceCard;
